<atomic-message-bar *ngIf="showPriorityWarning" type="warn" [shadow]="false">
	<p>
		{{ article }}
		<span class="cursor-pointer underline" (click)="editPriority()">{{
			showPriorityWarning
		}}</span>
		with {{ priority }} priority already exists.
	</p>
</atomic-message-bar>
